<ngx-spinner [fullScreen]="false" bdColor="rgba(0, 0, 0, 0)" style="margin-top: 0%;" color="#003478" size="medium"
  type="ball-spin-clockwise">
  <p style="font-size: 20px; font-family: Verdana,Arial,Helvetica,Trebuchet,_sans; color: black;">{{'Loading_DC_Session_Info'|translate}}</p>
</ngx-spinner>
<p class="header">{{'DC_Header'|translate}}</p>
<table *ngIf='showSessionTable == "true"' class='dummyTbl' cellpadding="2" cellspacing="0">
  <tbody>
    <tr>
      <th class='headerStyles'>
      </th>
      <th class='headerStyles'>{{'Dates'|translate}}</th>
      <th class='headerStyles'>{{'Start Time'|translate}}</th>
      <th class='headerStyles'>{{'Dealer Code'|translate}}</th>
      <th class='headerStyles'>{{'Technician'|translate}}</th>
      <th class='headerStyles'></th>
    </tr>
    <tr *ngFor="let list of dummySessionDetails" class="rowClass">
      <td></td>
      <td>{{list.createdTimeStamp | date: 'dd/MM/yyyy'}}</td>
      <td>{{list.createdTimeStamp | date :'h:mm a'}}</td>
      <td>{{list.sbdsouser.dealerCode}}</td>
      <td>{{list.sbdsouser.username}}</td>
      <td>
        <input type="button" id="dummySessionView" value="{{'View'|translate}}"
          (click)="viewDataCollectorInfo(list.createdTimeStamp,list.vin)">
      </td>
    </tr>
  </tbody>
</table>
<p class='noData' *ngIf="showSessionTable == 'false'">{{'No_session_Info'|translate}}</p>